import { validation } from 'site-modules/shared/components/form-validation/validation';
import { asyncValidation } from 'site-modules/shared/components/form-validation/validation-async';

export const MAX_REVIEW_TEXT_LENGTH = 7500;
export const FIELD_DANGER_CLASS_NAMES = 'field-danger text-danger medium mb-0_25';
export const FORM_FIELD_CLASS_NAMES = {
  className: 'mb-0',
  labelClassName: 'heading-5 mb-0_25',
};
export const LEGEND_STYLE = {
  marginBottom: 'unset',
  fontSize: 'unset',
};
export const SUBMIT_CTA = 'Submit Your Review';
export const UPDATE_CTA = 'Update Your Review';
export const FORM_FIELD_NAMES = {
  AUTHOR_NAME: 'authorName',
  EMAIL: 'email',
  USER_RATING: 'userRating',
  TITLE: 'title',
  TEXT: 'text',
  BODY_TYPE: 'bodytype',
  STYLE_ID: 'styleId',
  PERFORMANCE: 'performanceRating',
  COMFORT: 'comfortRating',
  INTERIOR: 'interiorRating',
  SAFETY: 'safetyRating',
  TECHNOLOGY: 'technologyRating',
  RELIABILITY: 'reliabilityRating',
  VALUE: 'valueRating',
  AGE: 'age',
  HEIGHT: 'height',
  WEIGHT: 'weight',
  KIDS_UNDER_TWELVE: 'kidsUnderTwelve',
  MILES_PER_YEAR: 'milesPerYear',
  DRIVING_TERRAIN: 'drivingTerrain',
};
export const FORM_VALIDATORS = {
  [FORM_FIELD_NAMES.AUTHOR_NAME]: {
    test: validation.validateUsername,
    errorText: 'Please add Author Name or Nickname',
  },
  [FORM_FIELD_NAMES.EMAIL]: {
    test: validation.validateEmail,
    asyncTest: (params, options) => asyncValidation.fetchEmailValidation({ ...params, id: 'insider' }, options),
    errorText: 'Please add an email address',
  },
  [FORM_FIELD_NAMES.USER_RATING]: {
    test: validation.validateValue,
    errorText: 'Please add an overall rating',
  },
  [FORM_FIELD_NAMES.TITLE]: {
    test: validation.validateValue,
    errorText: 'Please add a review title',
  },
  [FORM_FIELD_NAMES.TEXT]: {
    test: validation.validateValue,
    errorText: 'Please add a review',
  },
  [FORM_FIELD_NAMES.BODY_TYPE]: {
    test: validation.validateValue,
    errorText: 'Please add a vehicle type',
  },
  [FORM_FIELD_NAMES.STYLE_ID]: {
    test: validation.validateValue,
    errorText: 'Please add a vehicle model',
  },
  [FORM_FIELD_NAMES.PERFORMANCE]: { test: validation.validateValue },
  [FORM_FIELD_NAMES.COMFORT]: { test: validation.validateValue },
  [FORM_FIELD_NAMES.INTERIOR]: { test: validation.validateValue },
  [FORM_FIELD_NAMES.SAFETY]: { test: validation.validateValue },
  [FORM_FIELD_NAMES.TECHNOLOGY]: { test: validation.validateValue },
  [FORM_FIELD_NAMES.RELIABILITY]: { test: validation.validateValue },
  [FORM_FIELD_NAMES.VALUE]: { test: validation.validateValue },
  [FORM_FIELD_NAMES.AGE]: { test: validation.validateValue },
  [FORM_FIELD_NAMES.HEIGHT]: { test: validation.validateValue },
  [FORM_FIELD_NAMES.WEIGHT]: { test: validation.validateValue },
  [FORM_FIELD_NAMES.KIDS_UNDER_TWELVE]: { test: validation.validateValue },
  [FORM_FIELD_NAMES.MILES_PER_YEAR]: { test: validation.validateValue },
  [FORM_FIELD_NAMES.DRIVING_TERRAIN]: { test: validation.validateValue },
};

export const EMAIL_NOT_MATCH_ERROR = 'Sorry, your email does not match this review.';

export const STEP_NUMBER = {
  STEP_1: 1,
  STEP_2: 2,
  STEP_3: 3,
  STEP_4: 4,
  STEP_5: 5,
  STEP_TRY_AGAIN: 6,
};
export const ADDITIONAL_RATINGS = {
  FIELDS_1: [
    { label: 'Performance', name: FORM_FIELD_NAMES.PERFORMANCE },
    { label: 'Comfort', name: FORM_FIELD_NAMES.COMFORT },
    { label: 'Interior', name: FORM_FIELD_NAMES.INTERIOR },
    { label: 'Safety', name: FORM_FIELD_NAMES.SAFETY },
  ],
  FIELDS_2: [
    { label: 'Technology', name: FORM_FIELD_NAMES.TECHNOLOGY },
    { label: 'Reliability', name: FORM_FIELD_NAMES.RELIABILITY },
    { label: 'Value', name: FORM_FIELD_NAMES.VALUE },
  ],
};
export const AUTHOR_INFO_OPTIONS = [
  {
    name: FORM_FIELD_NAMES.AGE,
    label: 'Your age',
    options: [
      { label: 'Under 30', value: 'UNDER_30' },
      { label: '30 - 45', value: 'BETWEEN_30_45' },
      { label: '46 - 60', value: 'BETWEEN_46_60' },
      { label: 'Over 60', value: 'OVER_60' },
    ],
  },
  {
    name: FORM_FIELD_NAMES.HEIGHT,
    label: 'Your height',
    options: [
      { label: 'Under 5’2”', value: 'UNDER52' },
      { label: '5’2” - 6’', value: 'BETWEEN_52_511' },
      { label: 'Over 6’', value: 'OVER6' },
    ],
  },
  {
    name: FORM_FIELD_NAMES.WEIGHT,
    label: 'Your weight',
    options: [
      { label: 'Under 125', value: 'UNDER125' },
      { label: '125 - 175', value: 'BETWEEN_126_175' },
      { label: '176 - 225', value: 'BETWEEN_175_225' },
      { label: 'Over 225', value: 'OVER225' },
    ],
  },
  {
    name: FORM_FIELD_NAMES.KIDS_UNDER_TWELVE,
    label: 'Kids under 12 years',
    options: [
      { label: 'Yes', value: 'YES' },
      { label: 'No', value: 'NO' },
    ],
  },
  {
    name: FORM_FIELD_NAMES.MILES_PER_YEAR,
    label: 'Miles driven per year',
    options: [
      { label: '0 - 10,000', value: 'TO_10K' },
      { label: '10,000 - 15,000', value: 'BETWEEN_10K_15K' },
      { label: '15,000 - 20,000', value: 'BETWEEN_15K_20K' },
      { label: 'Over 20,000', value: 'OVER_20K' },
    ],
  },
  {
    name: FORM_FIELD_NAMES.DRIVING_TERRAIN,
    label: 'City vs highway driving',
    options: [
      { label: 'Mostly city', value: 'CITY' },
      { label: 'Mostly highway', value: 'HIGHWAY' },
      { label: 'Mixed', value: 'MIXED' },
    ],
  },
];
